export enum LeadTimeStatusEnum {
  WARNING = 'warning',
  SUCCESS = 'finish',
  PROCESS = 'process'
}
